<script lang="ts">
	import IconButton from '../../../../basic/buttons/IconButton.svelte';
	import { contextMenuState } from '../../../../basic/contextmenu/ContextMenuStore';
	import { confirmState } from '../../../../basic/dialog/ConfirmStore';
	import { getColorForString } from '../../../../helper/Colors';
	import { handleStoreError } from '../../../../stores/GeneralStore';
	import type { SettingDocumentNameGeneratorStore } from '../../../../stores/SettingDocumentNameGeneratorsStore.svelte';
	import type { SettingDocumentNameGenerator } from '../../../../types/BasicTypes';
	import type { MultiSelectionItem } from '../../../../types/ListTypes';
	import { _ } from 'svelte-i18n';

	interface Props {
		store: SettingDocumentNameGeneratorStore;
		item: SettingDocumentNameGenerator;
		onClick: (e: MouseEvent) => void;
		onChildDeleted: () => void;
		onEditRequest: (item: MultiSelectionItem) => void;
	}

	let { store, item, onClick, onChildDeleted, onEditRequest }: Props = $props();
	let showMenu: boolean = $state(false);

	async function openContextMenu(e: MouseEvent) {
		e.stopPropagation();

		const menuItems = [
			{
				title: $_('general.lbl_edit'),
				callbackFunction: () => {
					onEditRequest(item);
				}
			},
			{
				title: $_('general.lbl_delete'),
				danger: true,
				callbackFunction: () => {
					$confirmState = {
						bodyText: $_('settings.basic.document_name_generators.lbl_delete_modal').replace(
							'{}',
							item.defaultName
						),
						successCallback: deleteSettingDocumentNameGenerator,
						warningText: $_('settings.basic.document_name_generators.lbl_delete_warning'),
						securityCheckText: item.defaultName,
						acceptButtonText: $_('general.lbl_delete')
					};
				}
			}
		];

		$contextMenuState = {
			x: e.clientX,
			y: e.clientY,
			menuItems: menuItems
		};
	}

	async function deleteSettingDocumentNameGenerator() {
		try {
			await store.deleteSettingDocumentNameGeneratorStore(item.id);
			onChildDeleted();
		} catch (err) {
			handleStoreError('settings.basic.document_name_generators.err_delete', err);
		}
	}
</script>

<button
	onclick={onClick}
	onmouseenter={() => {
		showMenu = true;
	}}
	onmouseleave={() => {
		showMenu = false;
	}}
	class="rounded-[5px] bg-white dark:bg-dark-400 p-4 text-left relative"
	oncontextmenu={(e: MouseEvent) => {
		e.preventDefault();
		openContextMenu(e);
	}}
>
	<div>
		<div class="flex gap-2 items-center">
			<div
				class="w-4 h-4 rounded flex-shrink-0"
				style="background-color: {getColorForString(item.pattern ? item.pattern.toString() : '')};"
			></div>
			<p class="font-bold">{item.defaultName}</p>
		</div>

		<div class="flex justify-between mt-4">
			<p class=" truncate">{item.pattern}</p>
			<p class="">
				{item.startingNumber.toString().padStart(item.minNumberLength, '0')}
			</p>
		</div>

		<div class="absolute bottom-2 right-2">
			{#if showMenu}
				<IconButton
					iconName="ellipsis-h"
					onClick={openContextMenu}
					showCircle={false}
					size="small"
				/>
			{/if}
		</div>
	</div>
</button>
